import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import {
  MibAvatarComponent,
  MibBareButtonDirective,
  MibBreakpointService,
  MibHeaderComponent,
  MibHeaderEndDirective,
  MibLogoMedinboxComponent,
  MibLogoSymbolComponent,
  MibMenuComponent,
  MibMenuTriggerDirective,
} from '@medinbox/angular';
import { PermissionService } from '@core/permissions';
import { CaseTabs } from '../case-tabs/case-tabs';
import { MainMenu } from '@features/main-menu';
import { HeaderSlot } from './header-slot';

/** The application bar, rendered once by the layout: brand, page-declared middle, account block. */
@Component({
  selector: 'mai-header-bar',
  imports: [
    MibHeaderComponent,
    MibHeaderEndDirective,
    MibLogoMedinboxComponent,
    MibLogoSymbolComponent,
    MibBareButtonDirective,
    MibAvatarComponent,
    MibMenuComponent,
    MibMenuTriggerDirective,
    MainMenu,
    CaseTabs,
    RouterLink,
    NgTemplateOutlet,
  ],
  templateUrl: './header-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBar {
  private readonly breakpoints = inject(MibBreakpointService);
  protected readonly slot = inject(HeaderSlot);
  protected readonly permissions = inject(PermissionService);

  /** On the phone layout the panel carries the name instead. */
  protected readonly nameInBar = computed(() => this.breakpoints.sizeClass() === 'expanded');
  protected readonly fillsBar = computed(() => this.slot.middle()?.fillsBar() ?? false);
}
